export default "__VITE_ASSET__c2e25fd1__"